import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import Product from "../components/Product";
import PPEForm from "../components/PPEForm";
import Specifications from "../components/Specifications";

// Import data from helpers
import { disposableMasksProducts } from "../helpers/disposable-masks/products";
import { disposableMasksFormFields } from "../helpers/disposable-masks/formConfig";
import { disposableMasksSpecifications } from "../helpers/disposable-masks/specifications";

const DisposableMasks: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Disposable Masks Quote",
      path: "/disposable-masks.html",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Page Title and Products - Unified Container */}
        <div className="w-full py-8 bg-white">
          <div className="page-container">
            <h1 className="page-title">
              Disposable Face Masks in Bulk
            </h1>
            <p className="page-description">
              <strong>IN STOCK - Ships within 24-48 Hours from USA</strong>
            </p>
            <p className="page-description">
              Our Disposable 3-Ply and KN95 Face Masks are made of the strong,
              but lightweight and breathable, multi-layer material designed for
              comfortable protection based on your needs. The adjustable ear
              loops and nose clip allow for a tight and secure fit to cover your
              mouth and nose, effectively protecting you from airborne
              particles. Simply request a quote below and we'll send our best
              pricing for bulk 3-Ply (available in light blue and black) or KN95
              face masks (available in white and black).
            </p>
            
            {/* Product Grid */}
            <div className="mt-8">
              <Product products={disposableMasksProducts} aspectRatio="disposable" />
            </div>
          </div>
        </div>

        {/* Get Started Form */}
        <PPEForm
          title="Get Started"
          description="Get in touch today or call"
          phoneNumber="877-927-3691"
          fields={disposableMasksFormFields}
          formName="Disposable Masks PPE.us"
        />

        {/* KN95 Mask Specifications */}
        <Specifications
          title="KN95 Face Mask Specifications"
          items={[disposableMasksSpecifications[0]]}
        />

        {/* 3 Ply Face Mask Specifications */}
        <Specifications
          title="3 Ply Face Mask Specifications"
          items={[disposableMasksSpecifications[1]]}
        />
      </main>
    </div>
  );
};

export default DisposableMasks;
